enum Endpoints {
	// action types
	LOGIN = 'api/AdminUser/login',



	CLAIMS = 'api/Roles/Claims',

	LEAGUES = 'api/AdminLeagues',
	LEAGUES_ALL = 'api/AdminLeagues/AllLeagues',
	LEAGUES_FOR_FILTERS = 'api/AdminLeagues/AllLeagues',
	UPDATE_LEAGUES_ORDER = 'api/AdminLeagues/SetLeaguesOrders',
	UPDATE_LEAGUES = 'api/AdminLeagues/Update',
	DELETE_LEAGUES = 'api/AdminLeagues/Delete',

	MARKETS = 'api/AdminMarkets',
	ADD_MARKETS = 'api/AdminMarkets/Add',
	UPDATE_MARKETS = 'api/AdminMarkets/Update',

	TEXT_CONSTANTS = 'api/AdminTextConstant',
	ADD_TEXT_CONSTANTS = 'api/AdminTextConstant/Add',
	UPDATE_TEXT_CONSTANTS = 'api/AdminTextConstant/Update',
	
	TEAMS = 'api/AdminTeams',
	ADD_TEAMS = 'api/AdminTeams/Add',
	UPDATE_TEAMS = 'api/AdminTeams/Update',
	DELETE_TEAMS = 'api/AdminTeams/Delete',


	COUPONS = 'api/AdminCoupon',
	COUPONS_EXPIRED = 'api/AdminCoupon/Expired',
	COUPON_VALIDATE = 'api/AdminCoupon/ValidateCoupons',
	COUPON_UPDATE_STATUS = 'api/AdminCoupon/UpdateStatus',
	COUPON_CLEAR_TOURNAMENT = 'api/AdminCoupon/ClearTournamentId',
	COUPON_GOAL_TIMING = 'api/AdminCoupon/GoalTimingReport',

	COUNTRIES = 'api/AdminCountry',
	COUNTRIES_FOR_FILTERS = 'api/AdminCountry/AllCountries',
	TRANSACTIONS_FOR_FILTERS = 'api/AdminTransactions/TransactionTypes',
	ADD_COUNTRIES = 'api/AdminCountry/Add',
	UPDATE_COUNTRIES = 'api/AdminCountry/Update',
	DELETE_COUNTRIES = 'api/AdminCountry/Delete',

	GAMES = 'api/AdminGame/ForAdmin',
	SYNC_GAME = 'api/AdminGame/Sync',
	VALIDATE_COUPON = 'api/AdminCoupon/RevalidateGameCoupons',
	SINGLE_GAME = 'api/AdminGame',
	UPDATE_GAME = 'api/AdminGame/Update',
	GAMES_FOR_FILTERS = 'api/AdminGame',
	GAMES_FOR_FILTERS_NEW = 'api/AdminGame/ForFilters',

	GENERAL_SETTINGS = 'api/AdminGeneralSettings',
	PUSH_NOTIFICATIONS = 'api/AdminGeneralSettings/sendNotification',
	PUSH_NOTIFICATIONS_ADD = 'api/AdminGeneralSettings/sendNotification',
	SINGLE_GENERAL_SETTINGS = 'api/AdminGeneralSettings',
	HOME_HIGHLIGHTS_V2 = 'api/AdminGeneralSettings/HomeHighlightsV2',
	HOME_HIGHLIGHTS_V2_UPDATE = 'api/AdminGeneralSettings/HomeHighlightsV2',
	GENERATE_MATCH_COVER = 'api/AdminGeneralSettings/GenerateMatchCover',
	DELETE_IMAGE = 'api/AdminGeneralSettings/DeleteImage',
	PLAYERS_OF_PERIOD = 'api/AdminGeneralSettings/PlayersOfPeriodSetting',
	PLAYERS_OF_PERIOD_UPDATE = 'api/AdminGeneralSettings/PlayersOfPeriodSetting',
	REWARD_SETTINGS = 'api/AdminGeneralSettingsStatus',

	MISSIONS = 'api/AdminMissions',
	ADD_MISSION = 'api/AdminMissions',
	DELETE_MISSION = 'api/AdminMissions',
	MISSION_TYPES = 'api/AdminMissions/Types',
	MISSION_CATEGORIES = 'api/AdminMissions/Categories',
	UPDATE_MISSION = 'api/AdminMissions',
	ACTIVE_MISSIONS = 'api/AdminMissions/Active',

	ADMIN_DASHBOARD = 'api/AdminDashboard',
	ADMIN_DASHBOARD_V2 = 'api/AdminDashboardV2',


	TRANSACTIONS = 'api/AdminTransactions',
	ADD_TRANSACTION = 'api/AdminTransactions',
	DELETE_TRANSACTION = 'api/AdminTransactions',
	UPDATE_TRANSACTION = 'api/AdminTransactions',

	CLIENTS = 'api/Clients/Paginate',
	MULTIPLE_UPDATE_CLIENTS_COMMISSIONS = 'api/Orders/MultipleUpdateClientsCommission',
	CLIENTS_FOR_FILTERS = 'api/Clients',
	ADD_CLIENTS = 'api/Clients/Add',
	UPDATE_CLIENTS = 'api/Clients/Update',
	DELETE_CLIENTS = 'api/Clients/Delete',



	USERS = 'api/AdminUser',
	ADD_USERS = 'api/Authentication/register',
	UPDATE_USERS = 'api/AdminUser/Update',
	UPDATE_USERS_NICKNAME = 'api/AdminUser/UpdateNickName',
	DELETE_USERS = 'api/AdminUser/Delete',
	DISABLE_ENDPOINT = 'api/AdminUser/Disable',
	USERS_FOR_FILTERS = 'api/AdminUser/AdminForFilters',

	
	
	CATEGORIES = 'api/Categories',
	
	ADD_CATEGORIES = 'api/Categories/Add',
	UPDATE_CATEGORIES = 'api/Categories/Update',
	DELETE_CATEGORIES = 'api/Categories/Delete',
	
	CATEGORIES_CHILDREN = 'api/Categories/Children',
	UPDATE_CATEGORIES_CHILDREN = 'api/Categories/UpdateChildrensOrder',
	
	CATEGORIES_FOR_FILTERS = 'api/Categories',
	CLIENT_TYPES_FOR_FILTERS = 'api/ClientsTypes',
	ROLES_FOR_FILTERS = 'api/Roles',

	CLIENTS_COMMISSIONS = 'api/Orders/ClientsCommission',

	ADMIN_PURCHASES = 'api/AdminPurchase',
	ADMIN_POINTS = 'api/AdminPoints',
	ADMIN_TOURNAMENT = 'api/AdminTournament',
	ADMIN_TOURNAMENT_POINTS = 'api/AdminTournamentPoints',
	TOURNAMENTS_FOR_FILTERS = 'api/AdminTournament/AllTournaments',
	ADMIN_SPONSOR = 'api/AdminSponsor',
	SPONSORS_ALL = 'api/AdminSponsor/All',

	ADMIN_FAQ = 'api/AdminFaq',
	UPDATE_ADMIN_FAQ = 'api/AdminFaq/Update',
	ADMIN_FAQ_ORDER = 'api/AdminFaq/Order',

	BETTING_COMPANIES = 'api/AdminBettingCompanies',
	ADMIN_CONTACT_FORM = 'api/AdminContactForm',
	ADMIN_REPORT_AN_ISSUE = 'api/AdminReportAnIssue',

	MONITORING_EXCEPTIONS = 'api/AdminMonitoring/exceptions',
	MONITORING_HEALTH = 'api/AdminMonitoring/health',
	MONITORING_PLAN = 'api/AdminMonitoring/plan',
}

export { Endpoints };
